import styled from "styled-components";

export const Root = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: stretch;
  justify-content: flex-start;

  .trash-bin-icon {
    margin-right: 10px;
  }
`;

export const Separator = styled.div`
  margin-right: 10px;
`;

export const Section = styled.div`
  display: flex;
  width: 50%;
  height: 36px;
  flex-direction: row;
  align-items: stretch;
  justify-content: flex-start;
`;
export const Argument = styled.div`
  display: flex;
  width: 50%;
  flex-direction: row;
  align-items: stretch;
  justify-content: flex-start;

  .input-picker-group__plus-button,
  .pill-picker-editor__plus-button {
    top: 9px;
    right: 9px;
    display: inline-flex;
  }
`;
